import { QueryConfigTypes, createMetroApiConfig } from '@wix/premium-fed-sdk/@apis-infra';
import { CartApiTags } from './premium-cart.types';
import * as PremiumCartService from '@wix/ambassador-premium-cart-v1-cart/http';
export const PremiumCartApiConfig = createMetroApiConfig({
  getCart: PremiumCartService.getCart,
  getActiveCart: PremiumCartService.getActiveCart,
  applyCartActions: PremiumCartService.applyCartActions,
  createCheckout: PremiumCartService.createCheckout,
  removeLineItems: PremiumCartService.removeLineItems,
  ambassadorUpdateLineItems: PremiumCartService.updateLineItems,
  ambassadorAddLineItemsToActiveCart: PremiumCartService.addLineItemsToActiveCart,
  cancelActiveCart: PremiumCartService.cancelActiveCart
}, {
  methodsOptions: {
    getCart: {
      tags: [CartApiTags.cart]
    },
    getActiveCart: {
      tags: [CartApiTags.cart],
      queryConfigType: QueryConfigTypes.FIXED_DATA // TOCHECK - if its the same as staleTime infinity
    },
    applyCartActions: {
      queryConfigType: QueryConfigTypes.MUTATION_METHOD,
      tags: [CartApiTags.cart],
      isMutating: true
    },
    createCheckout: {
      queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH
    },
    cancelActiveCart: {
      isMutating: true,
      queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH,
      tags: [CartApiTags.cart]
    }
  }
});
//# sourceMappingURL=premium-cart.api-config.js.map